import $ from 'jquery';
import 'bootstrap';
import enableContactFunctionality from './contact';
import enableDiscoveryFlightFunctionality from './discovery-flight';
import enableInfoSessionsFunctionality from './info-sessions';
import enableScheduleAVisitFunctionality from './schedule-a-visit';
import enableNavigationBarFunctionality from './navigation-bar';
// wait until the DOM loads
$(() => {
    // enable common functionality
    enableNavigationBarFunctionality();
    // enable specific page functionality
    enableContactFunctionality();
    enableDiscoveryFlightFunctionality();
    enableInfoSessionsFunctionality();
    enableScheduleAVisitFunctionality();
});
